// @flow

import AppStore from "@cabonline/shared/stores/AppStore"

export default (new AppStore(): any)
